import type { CartItemDTO } from '../../application/dtos/CartDTO';
import { storageService } from '@/services/StorageService';

const CART_KEY = 'tfs_cart_cache';

export class LocalStorageCartAdapter {
  save(items: CartItemDTO[]): void {
    storageService.set(CART_KEY, items);
  }

  load(): CartItemDTO[] {
    return storageService.get<CartItemDTO[]>(CART_KEY) || [];
  }

  clear(): void {
    storageService.remove(CART_KEY);
  }
}
